import { render, staticRenderFns } from "./LsInfoRowLastCompleted.vue?vue&type=template&id=6bb20372&scoped=true&"
import script from "./LsInfoRowLastCompleted.vue?vue&type=script&lang=js&"
export * from "./LsInfoRowLastCompleted.vue?vue&type=script&lang=js&"
import style0 from "./LsInfoRowLastCompleted.vue?vue&type=style&index=0&id=6bb20372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb20372",
  null
  
)

export default component.exports